import React, { useRef } from 'react'
import Slider from 'react-slick'
import { breakpointsV2 } from 'spa/config/styled'
import styles from './JobOffersSlider.module.scss'
import { JobOfferSliderProps } from './types'
import { useWindowWidth } from 'spa/hooks/useWindowWidth'
import { MaterialSymbol } from '../../MaterialSymbol'
import { Card } from 'spa/member/components/Card'
import { Link } from 'react-router-dom'
import { FeaturedJobOfferJobOffer } from 'javascripts/api/generated/api'

const defaultSettings = {
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  className: styles.slider,
  speed: 500,
  dots: true,
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: breakpointsV2.desktop + 1,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: breakpointsV2.tablet + 1,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
  ],
  customPaging: () => <div className="slider-dot bg-member-gray-70 w-2 h-2 tablet:w-3 tablet:h-3 rounded-full" />,
}

const buildHeading = (jobOffer: FeaturedJobOfferJobOffer) => {
  return <div className={styles.heading}>{jobOffer.title}</div>
}

export const StyledJobOffersSlider: React.FC<JobOfferSliderProps> = ({ featuredJobOffers }) => {
  const sliderRef = useRef<Slider>(null)
  const windowWidth = useWindowWidth()
  const isDesktop = windowWidth >= breakpointsV2.desktop
  const isMobile = windowWidth < breakpointsV2.tablet
  const perPage = isDesktop ? 4 : isMobile ? 1 : 2

  const hasPage = featuredJobOffers.length > perPage

  const featured = isMobile ? featuredJobOffers.slice(0, 8) : featuredJobOffers

  return (
    <div className="relative">
      <Slider ref={sliderRef} {...defaultSettings} infinite={hasPage}>
        {
          featured.map(featuredJobOffer => (
            <a href={`/job_offers/${featuredJobOffer.jobOffer.id}`} key={featuredJobOffer.jobOffer.id}>
              <Card
                heading={buildHeading(featuredJobOffer.jobOffer)}
                pricing={String(featuredJobOffer.jobOffer.maxUnitPrice || '')}
                tags={[featuredJobOffer.skillName].filter(Boolean)}
                className={styles.card}
                style={{ width: 'unset', height: '202px' }}
              />
            </a>
          ))
        }
      </Slider>
      {hasPage && (
        <>
          <MaterialSymbol className={styles.arrowPrev} name="arrow_back_ios_new" onClick={() => sliderRef.current?.slickPrev()} />
          <MaterialSymbol className={styles.arrowNext} name="arrow_forward_ios" onClick={() => sliderRef.current?.slickNext()} />
        </>
      )}
    </div>
  )
}
